module.exports = require('./lib/noGetters');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-lazy-cache/noGetters.js
 ** module id = 613
 ** module chunks = 73
 **/